<template>
  <div id="app" ref="box">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>IP营</span>销
      </h1>
    </div>
    <div class="Marketing">
      <div class="IPtit">
        <h1>为品牌提供IP运用咨询&nbsp; 精准匹配优势资源</h1>
        <h1>量身设计和定制化方案帮助完成IP价值转化</h1>
      </div>
      <div class="IPpolymerization">
        <div class="first-btn">
          <img src="../assets/IP-img1.png" alt />
          <div class="IPTK" @click="displayAll">&gt;</div>
        </div>
        <div class="IPbgc">
          <div>
            <h1>
              <span>IP生态</span>聚合
            </h1>
            <p>网罗IP生态圈重量级伙伴</p>
            <p>挖掘细分类别的冉冉新星</p>
            <p>覆盖广泛场景 共筑IP生态</p>
          </div>
        </div>
      </div>
      <div class="IPdesign">
        <div class="IPbgc">
          <div class="IPbgc-second">
            <h1>
              IP创<span>意设计</span>
            </h1>
            <p>精准把握热点趋势</p>
            <p>深度洞察消费人群</p>
            <p>整合传播创意与产品设计</p>
            <p>全新升级消费者体验</p>
          </div>
        </div>
        <div class="second-btn">
          <img src="../assets/IP-img2.png" alt />
          <router-link to="/celuechuangyi">
            <div>&lt;</div>
          </router-link>
        </div>
      </div>
      <div class="IPintegration">
        <div class="third-btn">
          <img src="../assets/IP-img3.png" alt />
          <router-link to="/kehuanli">
            <div>&gt;</div>
          </router-link>
        </div>
        <div class="IPbgc">
          <div>
            <h1>
              <span>整合优</span>势资源
            </h1>
            <p>精准匹配资源 结合渠道特点优势</p>
            <p>资源整合和运用以寻找最优方案</p>
            <p>最大化品牌及合作伙伴价值</p>
          </div>
        </div>
      </div>
      <div></div>
      <div></div>
    </div>
    <BottomNav></BottomNav>
    <div class="IPBody" :style="display"></div>

    <!-- 弹框第一层 -->
    <div class="yingxiao-one" v-show="showdialog">
      <div class="IPtankuang2" :style="firstDisplay">
        <div class="IP2-tit">
          <span>全球IP匹配策略</span>
          <div @click="closeAll()">×</div>
        </div>
        <div class="yingxiao-one-bac">
          <img src="../assets/ipxiangqing/WechatIMG85.png" alt="">
          <img @click="showdialogtwo(0)" class="yingxiao-one-bac-one" src="../assets/ipimages/dishini.png" alt="">
          <img @click="showdialogtwo(5)" class="yingxiao-one-bac-two" src="../assets/ipimages/ppixarone.png" alt="">
          <img @click="showdialogtwo(5)" class="yingxiao-one-bac-three" src="../assets/ipimages/pixartwo.png" alt="">
          <img @click="showdialogtwo(5)" class="yingxiao-one-bac-four" src="../assets/ipimages/pixfour.png" alt="">
          <img @click="showdialogtwo(5)" class="yingxiao-one-bac-five" src="../assets/ipimages/pixfiv.png" alt="">
          <img @click="showdialogtwo(5)" class="yingxiao-one-bac-six" src="../assets/ipimages/pixsix.png" alt="">
          <img @click="showdialogtwo(2)" class="yingxiao-one-bac-dili" src="../assets/ipimages/dili.png" alt="">
          <img @click="showdialogtwo(8)" class="yingxiao-one-bac-gongzhu" src="../assets/ipimages/gongzhu.png" alt="">
          <img @click="showdialogtwo(7)" class="yingxiao-one-bac-tuomasi" src="../assets/ipimages/tuomasi.png" alt="">
          <img @click="showdialogtwo(4)" class="yingxiao-one-bac-line" src="../assets/ipimages/line.png" alt="">
          <!-- weizhi -->
          <img class="yingxiao-one-bac-shiziwan1" src="../assets/ipimages/shiziwang1.png" alt="">
          <img class="yingxiao-one-bac-shiziwan2" src="../assets/ipimages/shiziwan2.png" alt="">
          <img class="yingxiao-one-bac-shiziwan3" src="../assets/ipimages/shiziwan3.png" alt="">
          <img class="yingxiao-one-bac-shiziwan4" src="../assets/ipimages/shiziwan4.png" alt="">
          <img @click="showdialogtwo(3)" class="yingxiao-one-bac-huanqiu" src="../assets/ipimages/huanqiu.png" alt="">
          <img @click="showdialogtwo(1)" class="yingxiao-one-bac-feixue" src="../assets/ipimages/feixue.png" alt="">
          <img @click="showdialogtwo(3)" class="yingxiao-one-bac-panda" src="../assets/ipimages/pada.png" alt="">

        </div>
      </div>
    </div>

    <!-- ip详情弹框 -->
    <div class="yingxiao-two" v-show="showdialog2">
      <div class="IPtankuang2" v-for="item in iplist" v-show="item.visible" :key="item.id">
        <div class="IP2-tit">
          <span>{{ item.title }}</span>
          <div @click="closeAlldetail(item.id)">×</div>
        </div>
        <div class="yingxiao-two-bac">
          <img :src="item.imgsrc" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Marketing",
  data() {
    return {
      display: [{ display: "none" }],
      firstDisplay: [{ display: "none" }],
      secondDisplay: [{ display: "none" }],
      swiperDisplay: [{ display: "none" }],
      showdialog: false,
      showdialog2: false,
      iplist: [
        {
          id: 0,
          title: '迪士尼',
          imgsrc: require("../assets/ipxiangqing/dishini.jpg"),
          visible: true
        },
        {
          id: 1,
          title: '费雪',
          imgsrc: require("../assets/ipxiangqing/feixue.jpg"),
          visible: false
        },
        {
          id: 2,
          title: '国家地理',
          imgsrc: require("../assets/ipxiangqing/huojiadili.jpg"),
          visible: false
        },
        {
          id: 3,
          title: '环球',
          imgsrc: require("../assets/ipxiangqing/huanqiu.jpg"),
          visible: false
        },
        {
          id: 4,
          title: 'LINE FRIENDS',
          imgsrc: require("../assets/ipxiangqing/linefriends.jpg"),
          visible: false
        },
        {
          id: 5,
          title: '皮克斯',
          imgsrc: require("../assets/ipxiangqing/pikesi.jpg"),
          visible: false
        },
        {
          id: 6,
          title: '巧虎',
          imgsrc: require("../assets/ipxiangqing/qiaohu.jpg"),
          visible: false
        },
        {
          id: 7,
          title: '托马斯和朋友们',
          imgsrc: require("../assets/ipxiangqing/tuomasi.jpg"),
          visible: false
        },
        {
          id: 8,
          title: '迪士尼公主',
          imgsrc: require("../assets/ipxiangqing/gongzhu.jpg"),
          visible: false
        },
      ]
    };
  },
  methods: {
    closeAll() {
      this.display = { display: "none" };
      this.showdialog  = false
      this.firstDisplay = [{ display: "none" }];
      this.secondDisplay = [{ display: "none" }];
      this.swiperDisplay = [{ display: "none" }];
    },
    displayAll() {
      this.display = { display: "block" };
      this.showdialog = true
      this.firstDisplay = [{ display: "block" }];
    },
    closeAlldetail (id) {
      this.showdialog2 = false
      this.iplist.filter(item => item.id === id)[0].visible = false
    },
    showdialogtwo (id) {
      this.showdialog2 = true
      this.iplist.filter(item => item.id === id)[0].visible = true
    }
  },
  mounted() {
    if (this.$route.params.aa == 1) {
      // $('body').scrollTop(500)
      document.documentElement.scrollTop = 500;
    }
    var swiper = new Swiper(".swiper-container", {
      observer: true,
      observerParents: true,
      // 如果需要分页器
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
};
</script>

<style scoped lang="less">
.yingxiao-one {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  &-bac {
    position: relative;
    &-one {
      position: absolute;
      left: 148px;
      top: 25px;
      cursor: pointer;

      &:hover {
        transform: scale(1.1);
      }
    }
    &-two {
      position: absolute;
      left: 81px;
      top: 256px;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &-three {
      position: absolute;
      left: 79px;
      top: 445px;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &-four {
      position: absolute;
      left: 268px;
      top: 277px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-five {
      position: absolute;
      left: 142px;
      top: 359px;
      cursor: pointer;
    }
    &-six {
      position: absolute;
      left: 248px;
      top: 426px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-dili {
      position: absolute;
      left: 446px;
      top: 75px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-gongzhu {
      position: absolute;
      left: 416px;
      cursor: pointer;
      top: 349px;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-tuomasi {
      position: absolute;
      left: 664px;
      top: 19px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-line {
      position: absolute;
      left: 734px;
      top: 410px;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &-shiziwan1 {
      position: absolute;
      left: 749px;
      top: 135px;
      z-index: 300;
    }
    &-shiziwan2 {
      position: absolute;
      left: 809px;
      top: 160px;
    }
    &-shiziwan3 {
      position: absolute;
      left: 919px;
      top: 105px;
    }
    &-shiziwan4 {
      position: absolute;
      left: 837px;
      top: 285px;
    }
    &-huanqiu {
      position: absolute;
      left: 876px;
      top: 437px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-feixue {
      position: absolute;
      left: 1039px;
      top: 25px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
    &-panda {
      position: absolute;
      left: 1020px;
      top: 308px;
      cursor: pointer;
       &:hover {
        transform: scale(1.1);
      }
    }
  }
}
.yingxiao-two {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  background-color: transparent;
  z-index: 20000;

  .IPtankuang2{
    z-index: 20000 !important;
    display: block;
    img {
      width: 100%;
    }
  }

}

</style>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
  position: relative;
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 2px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  min-width: 1200px;
  background-color: #333333;
  height: 100px;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    font-weight: bold;
    @media screen and (min-width: 140px) {
        font-size: 24px;
      }
    @media screen and (min-width: 1440px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.Marketing {
  width: 65%;
  margin: 0 auto;
  padding-bottom: 100px;
  .IPtit {
    padding: 50px 0 20px 0;
    h1 {
      margin: 0;
      font-weight: bold;
      color: #333;
      @media screen and (min-width: 140px) {
        font-size: 24px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 26px;
      }
    }
  }
  .IPpolymerization {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    & > div {
      width: 50%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
      & > div {
        text-align: left;
        margin-left: 114px;
        display: inline-block;
        h1 {
          margin: 0;
          width: 100%;
          padding-bottom: 30px;
          font-weight: bold;
          color: #333;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
          span {
            border-bottom: 4px solid #fce04f;
            padding-bottom: 5px;
          }
        }
        p {
          margin: 0;
          line-height: 30px;
          width: 100%;
          width: 200px;
          color: rgba(102, 102, 102, 1);
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
  }
  .IPdesign {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    & > div {
      width: 50%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
      .IPbgc-second {
        width: 100%;
        margin-right: 111px;
        display: inline-block;
        text-align: right;
        h1 {
          margin: 0;
          width: 100%;
          padding-bottom: 30px;
          font-weight: bold;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
          span {
            border-bottom: 4px solid #fce04f;
            padding-bottom: 5px;
          }
        }
        p {
          margin: 0;
          line-height: 30px;
          width: 100%;
          font-size: 16px;
          color: #666666;
        }
      }
    }
  }
  .IPintegration {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: 0 auto;
    & > div {
      width: 50%;
      display: flex;
      align-items: center;
      img {
        width: 100%;
      }
      & > div {
        margin-left: 114px;
        display: inline-block;
        text-align: left;
        h1 {
          margin: 0;
          width: 100%;
          padding-bottom: 30px;
          font-weight: bold;
          @media screen and (min-width: 140px) {
            font-size: 18px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 24px;
          }
          span {
            border-bottom: 4px solid #fce04f;
            padding-bottom: 5px;
          }
        }
        p {
          margin: 0;
          line-height: 30px;
          width: 100%;
          color: rgba(102, 102, 102, 1);
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
  }
}
.IPbgc {
  background: rgba(51, 51, 51, 0.03);
}
.first-btn {
  position: relative;
  div {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 100;
    width: 66px;
    height: 113px;
    background-color: #fce04f;
    font-size: 50px;
    line-height: 113px;
    padding-left: 43px;
    text-align: center;
    // @media screen and (min-width: 140px) {
    //   min-width: 1050px;
    //   margin: 0 auto;
    // }
    // @media screen and (min-width: 1920px) {
    //   min-width: 1240px;
    //   margin: 0 auto;
    // }
  }
  div:hover {
    cursor: pointer;
  }
}
.second-btn {
  position: relative;
  & > a {
    div {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 100;
      width: 109px;
      height: 113px;
      background-color: #fce04f;
      font-size: 50px;
      line-height: 113px;
      text-align: center;
      color: #000;
    }
  }
}
.third-btn {
  position: relative;
  & > a {
    div {
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 100;
      width: 66px;
      height: 113px;
      background-color: #fce04f;
      font-size: 50px;
      line-height: 113px;
      padding: 0 21px;
      text-align: center;
      color: #000;
    }
  }
}
.IPBody {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  opacity: 0.8;
  z-index: 1000;
}
.IPtankuang {
  position: absolute;
  top: 0px;
  // left: 50%;
  // margin-left: -620px;
  width: 1240px;
  height: 602px;
  z-index: 10000;
  .IP-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .IPFather {
    background-color: #ffffff;
    padding: 0 96px 20px 70px;
    position: relative;
    .IPimg {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      padding-top: 10px;
      padding-bottom: 50px;
      .img-left {
        position: relative;
        padding-right: 17px;
        .img-left-top {
          width: 278px;
          height: 460px;
          background: rgba(252, 224, 79, 1);
          .IP-second-1 {
            padding: 33px;
            img {
              width: 56px;
              height: 56px;
            }
            p {
              margin-top: 17px;
              color: #333;
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
          .IP-second-2 {
            display: flex;
            justify-content: space-between;
            padding: 0 33px;
            img {
              width: 64px;
              height: 64px;
            }
            p{
              line-height: 25px;
              color: #333;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
          & > p {
            width: 240px;
            height: 100px;
            color: #333;
            padding: 0 19px;
            text-align: left;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
        .img-left-bottom {
          position: absolute;
          width: 278px;
          height: 460px;
          background: rgba(51, 51, 51, 1);
          top: 28px;
          left: -28px;
          z-index: -1;
        }
      }
      .img-right {
        position: relative;
        img {
          width: 840px;
          height: 486px;
        }
        .floatImg {
          width: 744px;
          height: 404px;
          position: absolute;
          top: 24px;
          left: 31px;
        }
      }
    }
  }
  .IP-bg {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
  }
}
.IPtankuang2 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1240px;
  transform: translate(-50%, -50%);
  z-index: 10000;
  .IP2-tit {
    padding: 0 96px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 27px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .IP2Father {
    background-color: #ffffff;
    padding: 0 96px 20px 70px;
    position: relative;
    .IP2img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      padding-top: 54px;
      padding-bottom: 50px;
      margin-left: -10px;
      .img-left {
        position: relative;
        width: 162px;
        height: 403px;
        background-color: #fce04f;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 114px;
          height: 70px;
        }
      }
      .img-middle {
        position: relative;
        border: 1px solid #666;
        border-left: none;
        padding: 0 20px 0 32px;
        display: flex;
        align-items: center;
        img {
          width: 287px;
          height: 300px;
        }
      }
      .img-right {
        position: relative;
        border: 1px solid #666;
        border-left: none;
        padding: 0 19px 0 19px;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          min-width: 595px;
        }
      }
    }
  }
  .IP2-bg {
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
  }
}
.swiper-container {
  width: 1240px;
  height: 589px;
  position: fixed;
  top: 50%;
  margin-top: -300px;
  left: 50%;
  margin-left: -620px;
  z-index: 10000;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 30px;
}
.swiper-button-next:after {
  margin-left: 5px;
  color: #fff;
}
.swiper-button-prev:after {
  margin-right: 5px;
  color: #fff;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-pagination{
  position: fixed;
  top: 790px;
  left: 48%;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  width: 20px;
  .swiper-pagination-bullet-active{
    color: #ccc;
  }
  &>span{
    margin-right: 50px;
  }
}
.swiper-pagination-bullet{
  margin-right: 10px!important;
}

</style>
<style lang="less">
// .el-submenu__title:hover {
//   background-color: #fff !important;
// }
:root {
  --swiper-theme-color: rgb(215,217,222) !important;
}
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}
// .el-carousel__container {
//   height: 500px;
// }
</style>